import { GetterTree } from "vuex";
import { IncomingTariffsItem, IncomingTariffsState } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<IncomingTariffsState, RootState> = {
  incomingTariffs(state): IncomingTariffsItem[] {
    return state.incomingTariffs;
  },
};
